<template>
  <div>
    <div class="account-creation">
      <video autoplay muted loop playsinline src="https://firebasestorage.googleapis.com/v0/b/plannervid.appspot.com/o/PlannerVid%20Media%20Assets%2FWebsite%20Video.mp4?alt=media&token=9b5ff789-a58a-4fa6-b57c-bc39a629b821"></video>
      <div class="component-section">
        <div class="logo">
            <img src="../../../public/resources/images/logos/PlannerVid Logo 1.png" alt="PlannerVid">
        </div>
        <router-view />
      </div>
      <div class="hero-section">
          <!-- <video autoplay muted loop playsinline src="https://uploads-ssl.webflow.com/605b76d61117d31dd609418a/60aeb005d4affdcecf34045f_hero-kolder-creative-opt-transcode.mp4"></video> -->
          <div class="content">
              <p>"<strong>Creativity</strong> is the <br>function of <strong>discipline and freedom</strong>."</p>
          </div>
      </div>
    </div>
    <cui-footer class="footer-background" />
  </div>
</template>

<script>
import CuiFooter from '@/components/cleanui/layout/Footer'

export default {
  name: 'PublicLayout',
  components: { CuiFooter },
}
</script>

<style lang="scss" scoped>
@import '@/components/mixins.scss';

.account-creation {
    // border: solid 3px red;
    // display: grid;
    // grid-template-columns: minmax(350px, 40%) 1fr;
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 auto;
    justify-content: center;
    height: 93vh;
    video {
        object-fit: cover;
        width: 100vw;
        height: 93vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.component-section {
    // border: solid 3px white;
    flex: 1 1 550px;
    // width: 40%;
    // height: 93vh;
    background: $dark-gray-6;
    padding: 2% 4%;
    z-index: 1;
}

.logo {
    img {
        width: 30%;
    }
}

.hero-section {
    // border: solid 3px white;
    flex: 1 1 550px;
    display: grid;
    place-items: center;
    padding: 4rem;
    backdrop-filter: blur(3px);
}

.hero-section:before {
    // border: solid 3px blue;
    content: '';
    position: absolute;
    background-image: linear-gradient(45deg, #000, #222);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: .5;
    // z-index: -1;
}

.content {
    // border: solid 3px blue;
    z-index: 1;
    font-size: 2rem;
    text-align: center;
}

.footer-background {
    background: $dark-gray-5;
    position: relative;
    bottom: 0;
}

</style>
